import EventBus from '@/eventBus'
import Socket from '@/socket'
import * as Sentry from '@sentry/vue'
import PresentationApi from '@/api/presentation'
import SlideApi from '@/api/slide'
import utils from '@/util'

const actions = {
  handleActiveSlidePptAddinWhenOpenLoadSlide({ rootState, dispatch }) {
    const isPresenting = utils.getParamValue('presenting')
    if (!rootState.isEnableAddinPowerpoint) return
    if (!isPresenting) return
    if (document.hidden) return
    dispatch('startActiveSlidePPT')
  },
  startActiveSlidePPT: async ({ rootState, dispatch }) => {
    try {
      if (!rootState.presentation.id || !rootState.slideActive.id) return
      if (!rootState.presentation.presenting) {
        EventBus.$emit('start-presenting-now')

        const payloadPresenting = {
          presenting: true,
          socketId: Socket.getSocketId(),
          activeSlidePreseting: rootState.slideActive.id,
          activeSlideAccessCode: rootState.presentation.uniqueAccessCode,
          presentFromPPT: true,
        }

        await PresentationApi.updatePresentationByPresentationId(
          rootState.presentation.id,
          payloadPresenting,
        )
      }
      const payloadSlide = {
        activeSlide: rootState.slideActive.id,
        socketId: Socket.getSocketId(),
        accessCode: rootState.presentation.uniqueAccessCode,
        timestamp: new Date().getTime(),
        from: 'startActiveSlidePPT',
      }
      if (rootState.slideActive.type !== 'leaderboard') {
        await SlideApi.updateNextSlideById(rootState.presentation.id, payloadSlide)
      }
      // rootState.presentation.activeSlide = rootState.slideActive.id
      // rootState.presentation.presenting = true
      dispatch('updatePresentation', {
        activeSlide: rootState.slideActive.id,
        presenting: true,
      }, { root: true })
      if (rootState.slideActive.type === 'leaderboard') {
        EventBus.$emit('sort-slide', async () => {
          await SlideApi.updateNextSlideById(rootState.presentation.id, payloadSlide)
        })
      }
    } catch (error) {
      Sentry.captureException(error)
    }
    // EventBus.$emit('makeSlideActive', this.$store.state.slideActive)
  },
}

export default actions
